import apiUseCases from "@src/cloud-connect/api";
import { PostGatewayOnboardResponse } from "@src/cloud-connect/api/client-configuration/post-gateway-onboard";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GatewayOnboardOnlyResult {
  success: boolean;
  data?: PostGatewayOnboardResponse;
  status?: number;
  error?: string;
}

export const gatewayOnboardOnlyUseCase = async (
  onboardingKey: string,
): Promise<GatewayOnboardOnlyResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postGatewayOnboard(
      namespace,
      onboardingKey,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    const parsed = parseAxiosApiError(error, "Failed to onboard gateway.");

    return {
      success: false,
      status: parsed.status,
      error: parsed.message,
    };
  }
};
